<template>
	<div class="home">
		<div
			v-once
			class="header"
		>
			Gaming Dashboard
		</div>
		<DigitalClock class="clock" />
		<ElapsedTimer class="elapsed" />
		<StopWatch class="stop-watch" />
		<AlarmList class="alarm-list" />
	</div>
</template>

<script>
import AlarmList from '@/components/AlarmList.vue';
import DigitalClock from '@/components/DigitalClock.vue';
import ElapsedTimer from '@/components/ElapsedTimer.vue';
import StopWatch from '@/components/StopWatch.vue';

export default {
	name: 'Home',
	components: {
		AlarmList,
		DigitalClock,
		ElapsedTimer,
		StopWatch,
	},
};
</script>

<style lang="stylus" scoped>
.home
	text-align center
	margin 0 auto
	display grid
	grid-template-columns 1fr 2fr 1fr
	grid-template-rows auto auto auto
	grid-template-areas\
		"header header header"\
		"clock clock clock"\
		"elapsed alarm-list stop-watch"

	> .header
		grid-area header
		background-color #111
		padding 10px
		font-size 2rem

	> .clock
		grid-area clock

	> .elapsed
		grid-area elapsed

	> .stop-watch
		grid-area stop-watch

	> .alarm-list
		grid-area alarm-list

	@media (max-width: 800px)
		grid-template-areas\
			"header header header"\
			"clock clock clock"\
			"elapsed elapsed elapsed"\
			"stop-watch stop-watch stop-watch"\
			"alarm-list alarm-list alarm-list"
		grid-row-gap 1rem
</style>



// WEBPACK FOOTER //
// src/views/Home.vue